PJQ.views.schedule.NewLookAheadModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'modal-edit-lookahead'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: async function () {
        if (this.model == null) {
            this.model = new PJQ.models.schedule.LookAhead({
                projectId: this.options.projectId
            });
        }

        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            lookAheads: this.options.lookAheads
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'select'
            ]
        });

        let minStart = null;
        if (this.options.lookAheads != null && _.size(this.options.lookAheads.models) > 0) {
            minStart = _.max(_.map(this.options.lookAheads.models, (lookAhead) => {
                return new Date(PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(lookAhead.get('start')), lookAhead.get('duration')));
            }));
        }

        if (minStart == null) {
            minStart = new Date();
        }

        if (this.model.get('start') == null) {
            this.model.set('start', minStart);
        }
        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-start-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.getDateString(minStart, PJQ.helpers.dateHelpers.dateFormats.DATE, true)
            },
            onChange: (newDate) => {
                this.model.set('start', newDate);
            }
        });

        if (this.model.get('duration') == null) {
            this.model.set('duration', 14);
        }
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-duration'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('duration')
        });

        if (this.options.lookAheads != null && _.size(this.options.lookAheads.models) > 0) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-use-look-ahead'),
                isIntChoices: true,
                isMultiple: false,
                defaultValue: 2,
                choices: _.map(this.options.lookAheads.models, (lookAhead) => {
                    return {
                        name: lookAhead.getDisplayName(),
                        value: lookAhead.id
                    };
                })
                // onChange: (value) => {
                //     this.model.set('')
                // }
            });
        }
    },
    validate: function () {
        if (this.validationAlert != null) {
            this.validationAlert.destroy();
        }

        if (this.options.schedule != null) {
            let lookAheadStart = new Date(this.model.get('start')),
                lookAheadFinish = PJQ.helpers.dateHelpers.getNewDateAddDays(lookAheadStart, this.model.get('duration'));
            if (null == _.find(this.options.schedule.tasks.models, (task) => {
                return PJQ.helpers.dateHelpers.checkDateRangesOverlap(task.get('start'), task.get('finish'), lookAheadStart, lookAheadFinish);
            })) {
                this.validationAlert = new PJQ.Alert(this.$('.modal-body'), {
                    text: "The Look Ahead date range does not contain with any tasks in the schedule. Please select a different date range.",
                    isPrepend: true,
                    type: 'warning'
                });
                return false;
            }
        }
        return true;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        this.model.save(null, {
            success: _.bind(function () {
                this.removeModal();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            error: _.bind(function (model, response) {
                // this.showErrors(response.responseJSON);
            }, this)
        });
    },
    // deleteTemplate: function () {
    // 	new PJQ.views.modals.DeleteCancel({
    // 		header: "Confirm Deletion",
    // 		body: "Are you sure you want to delete this template?",
    // 		onDelete: _.bind(function () {
    // 			if (typeof this.options.onDelete === 'function') {
    // 				this.options.onDelete(this.model);
    // 			}
    // 			this.removeModal();
    // 		}, this)
    // 	});
    // }
});